module.exports = __webpack_public_path__ + "img/xzapp_ewm.9b91568b.png";